import { render, staticRenderFns } from "./Step4_ExtraInfo.vue?vue&type=template&id=211f77c6&"
import script from "./Step4_ExtraInfo.vue?vue&type=script&lang=js&"
export * from "./Step4_ExtraInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports